export const formSubmmitMapper = (data) => ({
  id_jenis_anggaran: data?.idJenis,
  nama_jenis_anggaran: data?.namaJenis,
  keterangan: data?.keterangan,
});
